/**
 * Comparison View States
 */
export const CLOSED = 'closed';
export const SELECTING = 'selecting';
export const EXPAND = 'expand';
export const COLLAPSE = 'collapse';

export const MAX_CRUISES_AMMOUNT_MOBILE = 2;
export const MAX_CRUISES_AMMOUNT_TABLET = 3;
export const MAX_CRUISES_AMMOUNT_DESKTOP = 4;

export const MIN_CRUISES_AMMOUNT = 2;

export const COMPARE_PAGE_BASE_PATH = '/cruises/compare';

// export const OPENING = 'opening';
// export const COMPARING = 'comparing';
// export const CLOSING = 'closing';
